/** Checkout UI copy — EN / AR. City option values stay English for OTO. */

export const SAUDI_CITY_LABELS_AR = {
  Riyadh: 'الرياض',
  Jeddah: 'جدة',
  Dammam: 'الدمام',
  Khobar: 'الخبر',
  Dhahran: 'الظهران',
  Mecca: 'مكة',
  Medina: 'المدينة',
  Taif: 'الطائف',
  Tabuk: 'تبوك',
  Abha: 'أبها',
  'Khamis Mushait': 'خميس مشيط',
  Jizan: 'جازان',
  Najran: 'نجران',
  Hail: 'حائل',
  Buraidah: 'بريدة',
  Unaizah: 'عنيزة',
  Jubail: 'الجبيل',
  Yanbu: 'ينبع',
  'Al Ahsa': 'الأحساء',
  Hofuf: 'الهفوف',
  Qatif: 'القطيف',
  'Al Kharj': 'الخرج',
  Sakaka: 'سكاكا',
  Arar: 'عرعر',
  Other: 'أخرى',
}

export function cityLabel(city, isArabic) {
  if (!city) return ''
  if (!isArabic) return city
  return SAUDI_CITY_LABELS_AR[city] || city
}

export function getCheckoutCopy(isArabic) {
  if (!isArabic) {
    return {
      emptyTitle: 'Your cart is empty',
      emptyBody: 'Add products from the shop to checkout.',
      continueShopping: 'Continue Shopping',
      backToCart: 'Back to cart',
      signedInAs: 'Signed in as',
      switchAccount: 'switch account',
      guestCheckout: 'Guest checkout ·',
      signIn: 'Sign in',
      fasterNext: 'for faster checkout next time',
      stepDelivery: '1. Delivery address',
      fullName: 'Full name *',
      fullNamePh: 'First and last name',
      mobile: 'Mobile number *',
      mobileHint: 'Saudi mobile, e.g. 05xxxxxxxx',
      email: 'Email *',
      emailPh: 'for order updates',
      country: 'Country',
      countryValue: 'Saudi Arabia',
      city: 'City *',
      selectCity: 'Select city',
      district: 'Area / District *',
      districtPh: 'e.g. Al Olaya',
      street: 'Street name *',
      streetPh: 'Street name',
      building: 'Building number (optional)',
      buildingPh: '1234',
      stepShipping: '2. Shipping',
      liveRatesFor: 'Live rates for',
      selectCityForRates: 'Select your city above to see delivery options.',
      selectCityForLive: 'Select your city above to see live delivery options.',
      loadingRates: (city) => `Loading shipping rates for ${city}…`,
      orderToday: 'Order today',
      showBest: 'Show best options',
      noSameDay: 'No same-day cold couriers available for this city.',
      noCold: 'No cold shipping options available for this city.',
      stepPayment: '3. Payment',
      choosePayment: 'Choose card (Moyasar) or pay later with Tamara.',
      cardTitle: 'Card — Mada, Visa, Mastercard & more',
      cardSub: 'Amex, UnionPay & other major cards via Moyasar',
      tamaraTitle: 'Tamara — Buy now, pay later',
      tamaraChecking: 'Checking eligibility…',
      tamaraUnavailable: 'Not available for this order',
      tamaraSplit: 'Split your payment with Tamara',
      tamaraIneligible: 'Not eligible for Tamara on this order',
      continueTamara: 'Continue with Tamara',
      redirectingTamara: 'Redirecting to Tamara…',
      unlockPayment: 'Select a shipping option above to unlock payment.',
      orderSummary: 'Order summary',
      qty: 'Qty',
      promoCode: 'Promo code',
      promoWith: (name) => `Promo code — save with ${name}`,
      promoPh: 'e.g. AHMED10',
      apply: 'Apply',
      remove: 'Remove',
      percentOff: (n) => `${n}% off applied`,
      subtotal: 'Subtotal',
      discount: 'Discount',
      shipping: 'Shipping',
      selectOption: 'Select option',
      total: 'Total',
      payHintBefore: 'Complete delivery & shipping above, then pay',
      payHintAfter: 'using the secure form.',
      weAccept: 'We accept',
      payNote: 'Plus other major international cards where supported · Split with Tamara',
      // validation / toasts
      errEmptyCart: 'Your cart is empty',
      errName: 'Please enter your full name',
      errEmail: 'Please enter a valid email',
      errPhone: 'Enter a valid Saudi mobile (05xxxxxxxx)',
      errCity: 'Please select your city',
      errDistrict: 'Area / District is required',
      errStreet: 'Street name is required',
      errShipping: 'Please select a shipping option',
      errPromoEmpty: 'Enter a promo code',
      errPromoInvalid: 'Invalid promo code',
      errTamaraStart: 'Could not start Tamara checkout',
      errTamaraUrl: 'Tamara did not return a checkout URL',
      errNotEligible: 'This order is not eligible for Tamara',
      errSelectSpecificCity: 'Select a specific city for shipping rates',
      errNoRates: (city) => `No shipping options available for ${city}`,
      errLoadRates: 'Could not load shipping rates',
    }
  }

  return {
    emptyTitle: 'سلتك فارغة',
    emptyBody: 'أضف منتجات من المتجر لإتمام الطلب.',
    continueShopping: 'متابعة التسوق',
    backToCart: 'العودة إلى السلة',
    signedInAs: 'مسجّل الدخول باسم',
    switchAccount: 'تبديل الحساب',
    guestCheckout: 'الدفع كزائر ·',
    signIn: 'تسجيل الدخول',
    fasterNext: 'لإتمام الطلب بشكل أسرع في المرة القادمة',
    stepDelivery: '١. عنوان التوصيل',
    fullName: 'الاسم الكامل *',
    fullNamePh: 'الاسم الأول والأخير',
    mobile: 'رقم الجوال *',
    mobileHint: 'جوال سعودي، مثال: 05xxxxxxxx',
    email: 'البريد الإلكتروني *',
    emailPh: 'لتحديثات الطلب',
    country: 'الدولة',
    countryValue: 'المملكة العربية السعودية',
    city: 'المدينة *',
    selectCity: 'اختر المدينة',
    district: 'الحي / المنطقة *',
    districtPh: 'مثال: العليا',
    street: 'اسم الشارع *',
    streetPh: 'اسم الشارع',
    building: 'رقم المبنى (اختياري)',
    buildingPh: '1234',
    stepShipping: '٢. الشحن',
    liveRatesFor: 'أسعار الشحن لـ',
    selectCityForRates: 'اختر مدينتك أعلاه لعرض خيارات التوصيل.',
    selectCityForLive: 'اختر مدينتك أعلاه لعرض خيارات التوصيل المباشرة.',
    loadingRates: (city) => `جاري تحميل أسعار الشحن لـ ${city}…`,
    orderToday: 'اطلب اليوم',
    showBest: 'عرض أفضل الخيارات',
    noSameDay: 'لا تتوفر شركات شحن مبرّد في نفس اليوم لهذه المدينة.',
    noCold: 'لا تتوفر خيارات شحن مبرّد لهذه المدينة.',
    stepPayment: '٣. الدفع',
    choosePayment: 'اختر البطاقة (ميسر) أو ادفع لاحقاً مع تمارا.',
    cardTitle: 'بطاقة — مدى، فيزا، ماستركارد والمزيد',
    cardSub: 'أمريكان إكسبريس ويونيون باي وبطاقات أخرى عبر ميسر',
    tamaraTitle: 'تمارا — اشترِ الآن وادفع لاحقاً',
    tamaraChecking: 'جاري التحقق من الأهلية…',
    tamaraUnavailable: 'غير متاح لهذا الطلب',
    tamaraSplit: 'قسّم دفعتك مع تمارا',
    tamaraIneligible: 'هذا الطلب غير مؤهل لتمارا',
    continueTamara: 'المتابعة مع تمارا',
    redirectingTamara: 'جاري التحويل إلى تمارا…',
    unlockPayment: 'اختر خيار الشحن أعلاه لتفعيل الدفع.',
    orderSummary: 'ملخص الطلب',
    qty: 'الكمية',
    promoCode: 'رمز الخصم',
    promoWith: (name) => `رمز خصم — وفّر مع ${name}`,
    promoPh: 'مثال: AHMED10',
    apply: 'تطبيق',
    remove: 'إزالة',
    percentOff: (n) => `تم تطبيق خصم ${n}%`,
    subtotal: 'المجموع الفرعي',
    discount: 'الخصم',
    shipping: 'الشحن',
    selectOption: 'اختر خياراً',
    total: 'الإجمالي',
    payHintBefore: 'أكمل العنوان والشحن أعلاه، ثم ادفع',
    payHintAfter: 'عبر النموذج الآمن.',
    weAccept: 'نقبل الدفع عبر',
    payNote: 'بالإضافة إلى بطاقات دولية أخرى · قسّط مع تمارا',
    errEmptyCart: 'سلتك فارغة',
    errName: 'يرجى إدخال الاسم الكامل',
    errEmail: 'يرجى إدخال بريد إلكتروني صالح',
    errPhone: 'أدخل جوالاً سعودياً صالحاً (05xxxxxxxx)',
    errCity: 'يرجى اختيار المدينة',
    errDistrict: 'الحي / المنطقة مطلوب',
    errStreet: 'اسم الشارع مطلوب',
    errShipping: 'يرجى اختيار خيار الشحن',
    errPromoEmpty: 'أدخل رمز الخصم',
    errPromoInvalid: 'رمز الخصم غير صالح',
    errTamaraStart: 'تعذّر بدء الدفع عبر تمارا',
    errTamaraUrl: 'تمارا لم تُرجع رابط الدفع',
    errNotEligible: 'هذا الطلب غير مؤهل لتمارا',
    errSelectSpecificCity: 'اختر مدينة محددة لعرض أسعار الشحن',
    errNoRates: (city) => `لا تتوفر خيارات شحن لـ ${city}`,
    errLoadRates: 'تعذّر تحميل أسعار الشحن',
  }
}
